import { render, staticRenderFns } from "./Duplicate.vue?vue&type=template&id=9d5acc26&scoped=true&"
import script from "./Duplicate.vue?vue&type=script&lang=ts&"
export * from "./Duplicate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5acc26",
  null
  
)

export default component.exports